export const DRAWER_WIDTH = 280
export const DRAWER_MIN_WIDTH = 240
export const DRAWER_MAX_WIDTH = 320
